import { render, unmountComponentAtNode } from 'react-dom';

import { HonestSignModal } from './HonestSign';

export enum ESignModalType {
  ADD,
  REMOVE,
}

export enum ESignScanStatus {
  SUCCESS,
  CANCELED,
}

type TPromiseValue =
  | {
      status: ESignScanStatus.SUCCESS;
      sign: string;
    }
  | {
      status: ESignScanStatus.CANCELED;
    };

export const openHonestSignModal = (
  validator: (code: string) => Promise<{
    validate: boolean;
    errorMessage?: string;
  }>,
  type: ESignModalType = ESignModalType.ADD
): Promise<TPromiseValue> => {
  const modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', 'code-check');
  document.body.appendChild(modalRoot);

  if (!modalRoot) {
    console.error(
      'node with id modal-root is not exist in document, check html file'
    );
    return Promise.reject();
  }

  return new Promise<TPromiseValue>((resolve) => {
    render(
      <HonestSignModal
        validator={validator}
        onScan={(sign) => resolve({ status: ESignScanStatus.SUCCESS, sign })}
        onCancel={() => resolve({ status: ESignScanStatus.CANCELED })}
        type={type}
      />,
      modalRoot
    );
  }).finally(() => {
    unmountComponentAtNode(modalRoot);
    document.body.removeChild(modalRoot);
  });
};
